import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgGridView = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 3.25A1.75 1.75 0 0 0 3.25 5v4.5c0 .966.784 1.75 1.75 1.75h4.5a1.75 1.75 0 0 0 1.75-1.75V5A1.75 1.75 0 0 0 9.5 3.25zM4.75 5A.25.25 0 0 1 5 4.75h4.5a.25.25 0 0 1 .25.25v4.5a.25.25 0 0 1-.25.25H5a.25.25 0 0 1-.25-.25zM5 12.75a1.75 1.75 0 0 0-1.75 1.75V19c0 .966.784 1.75 1.75 1.75h4.5A1.75 1.75 0 0 0 11.25 19v-4.5a1.75 1.75 0 0 0-1.75-1.75zm-.25 1.75a.25.25 0 0 1 .25-.25h4.5a.25.25 0 0 1 .25.25V19a.25.25 0 0 1-.25.25H5a.25.25 0 0 1-.25-.25zM12.75 5c0-.966.784-1.75 1.75-1.75H19c.966 0 1.75.784 1.75 1.75v4.5A1.75 1.75 0 0 1 19 11.25h-4.5a1.75 1.75 0 0 1-1.75-1.75zm1.75-.25a.25.25 0 0 0-.25.25v4.5c0 .138.112.25.25.25H19a.25.25 0 0 0 .25-.25V5a.25.25 0 0 0-.25-.25zM14.5 12.75a1.75 1.75 0 0 0-1.75 1.75V19c0 .966.784 1.75 1.75 1.75H19A1.75 1.75 0 0 0 20.75 19v-4.5A1.75 1.75 0 0 0 19 12.75zm-.25 1.75a.25.25 0 0 1 .25-.25H19a.25.25 0 0 1 .25.25V19a.25.25 0 0 1-.25.25h-4.5a.25.25 0 0 1-.25-.25z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgGridView;
